export const redirectScreenDelayMs = 1500;

// Appended to cp.cfg.REACT_APP_P6_BASE_WEBSITE, which is only available at runtime.
export const personalDataWebsitePath = "schule/account/personal-data";
